import React from "react";
import course from "./CertificationApi.js";
import "./Certification.css";
// import "./../../../public/image/Certification_image/hero.jpg"
const Certification = () => {
  return (
    <>
      <section className="Certification" id="certification">
        <div className="container top">
          <div className="heading text-center">
            <h4>MY COURSES & CERTIFICATIONS</h4>
            <h1>Certification</h1>
          </div>

          <div>
            <ul role="list" className="divide-y divide-gray-100">
              {course.map((data) => (
                <li
                  key={data.name}
                  className="flex flex-col sm:flex-row justify-between gap-x-6 py-5 box btn_shadow"
                >
                  <div className="flex min-w-0 gap-x-4">
                    <img
                      alt=""
                      src={data.image}
                      className="h-12 w-12 flex-none rounded-full bg-gray-50"
                    />
                  </div>

                  <div className="flex-grow flex flex-col justify-between">
                    <div className="flex flex-col  md:flex-row justify-between">
                      <p className="text-sm font-semibold  text-gray-900">
                        {data.name}
                      </p>
                      <p className="text-sm font-semibold   text-gray-900">
                        {data.company}
                      </p>
                    </div>

                    <div className="shortP flex flex-col md:flex-row justify-between mt-2">
                      <p className="truncate text-xs  text-gray-500">
                        {data.link}
                      </p>
                      <p className="text-xs  text-gray-500">{data.date}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default Certification;
